/** @format */

import { useEffect } from "react";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import FadeLoader from "react-spinners/FadeLoader";
import Footer from "../components/Footer";
import Headers from "../components/Headers";
import { messageClear } from "../store/reducers/homeReducer";
import { useCategories } from "../utils/Categories";

const Blogs = () => {
  const navigate = useNavigate();
  const { loader, successMessage, messageError } = useSelector(
    (state) => state.auth,
  );
  const dispatch = useDispatch();

  const { categories, clientLocation } = useCategories();
  //console.log("categories ", categories)
  //if (loading) return <div>Loading...</div>;
  // if (errorMessage) return <div>Error: {errorMessage}</div>;
  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage);
      dispatch(messageClear());

      // navigate('/login');
    }
    if (messageError) {
      toast.error(messageError);
      dispatch(messageClear());
    }
  }, [successMessage, messageError, dispatch, navigate]);

  return (
    <div>
      {loader && (
        <div className='w-screen h-screen flex justify-center items-center fixed left-0 top-0 bg-gray-500/70 z-[99999]'>
          <FadeLoader />
        </div>
      )}
      <Headers categories={categories} clientLocation={clientLocation} />
      <div className='h-[1px] bg-black w-full my-2'></div>

      <div className='bg-white w-full justify-center items-center py-5'>
        <section
          className=' h-full flex justify-center items-center shadow-lg md-lg:flex md-lg:flex-col md-lg:w-[90%] md:w-[90%]  
                                sm:w-[95%] w-[85%] mx-auto bg-white'
        >
          <div className='w-[70%] px-4 py-2 md-lg:w-[100%]'>
            <h1 className='font-bold text-blue-400 text-3xl py-2'>
              Kimeyada.com lit
            </h1>
            <p className='text-xl font-semibold'>
              Votre source de connaissances, d'actualités et d'avis d'experts
              sur l'industrie
            </p>
          </div>
          <div className='w-[30%] px-4 py-2 md-lg:w-[100%]'>
            <input
              type='text'
              placeholder='Search'
              className='px-4 py-2 focus:border-indigo-500 outline-none
                        border border-slate-700 rounded-md text-[#d0d2d6]'
            />
          </div>
        </section>

        <section className=' h-full flex justify-center items-center md-lg:flex md-lg:flex-col md-lg:w-[90%] md:w-[90%]  sm:w-[95%] w-[85%] mx-auto bg-white'>
          <div className='w-[70%] pr-2 py-2 justify-center items-center mb-4 md-lg:w-[100%]'>
            <h1 className='font-bold text-black text-3xl py-5'>
              Dernières publications
            </h1>
            <div className='shadow-md px-4 py-4 mb-4 hover:shadow-indigo-500/30 cursor-pointer md-lg:w-[100%]'>
              <Link to={`/blog/blogdetails/789456`}>
                <img
                  className='justify-center items-center w-[90%] h-auto'
                  src={`https://img.baba-blog.com/2025/04/Chuwi.jpg?x-oss-process=style%2Ffull`}
                  alt='PC'
                />
              </Link>
              <p className='font-semibold text-black text-2xl py-5 px-4 hover:text-orange-500 cursor-pointer'>
                Revue CHUWI Aupad : une tablette économique qui surprend
                réellement
              </p>
              <div className='h-[1px] bg-slate-400 w-full my-2'></div>
              <span className='font-thin'>
                Posté par <span className='text-blue-400 '>Kimeyada</span> le
                12/02/2023
              </span>
            </div>
          </div>
          <div className='w-[30%] pl-2 py-2 flex flex-col gap-4 md-lg:w-[100%]'>
            <div className='mt-0 shadow-lg p-2 rounded-sm cursor-pointer hover:shadow-slate-200 border-gray-50'>
              <h3 className='text-slate-400 font-semibold text-xl'>
                Ventes & Marketing
              </h3>
              <div className='flex  md-lg:justify-between'>
                <div className='gap-2'>
                  <p className='text-semibold hover:text-orange-500 py-2 transition-all'>
                    Comment gagner de l''argent avec son telephone
                  </p>
                  <div className='h-[1px] bg-slate-400 w-full my-2 '></div>
                  <span className='font-thin'>
                    Posté par <span className='text-blue-400 '>Kimeyada</span>{" "}
                    le 12/02/2023
                  </span>
                </div>
                <img
                  className='justify-center items-center w-[100px] object-contain'
                  src={`${process.env.REACT_APP_CLIENT_URL}/images/pc.png`}
                  alt='PC'
                />
              </div>
            </div>

            <div className='mt-0 shadow-lg p-2 rounded-sm cursor-pointer hover:shadow-slate-200'>
              <h3 className='text-slate-400 font-semibold text-xl'>
                Ventes & Marketing
              </h3>
              <div className='flex md-lg:justify-between'>
                <div className='gap-2'>
                  <p className='text-semibold hover:text-orange-500 py-2 transition-all'>
                    Comment gagner de l''argent avec son telephone
                  </p>
                  <div className='h-[1px] bg-slate-400 w-full my-2 '></div>
                  <span className='font-thin'>
                    Posté par <span className='text-blue-400 '>Kimeyada</span>{" "}
                    le 12/02/2023
                  </span>
                </div>
                <img
                  className='justify-center items-center w-[100px] object-contain'
                  src={`${process.env.REACT_APP_CLIENT_URL}/images/pc.png`}
                  alt='PC'
                />
              </div>
            </div>

            <div className='mt-0 shadow-lg p-2 rounded-sm cursor-pointer hover:shadow-slate-200'>
              <h3 className='text-slate-400 font-semibold text-xl'>
                Ventes & Marketing
              </h3>
              <div className='flex md-lg:justify-between'>
                <div className='gap-2'>
                  <p className='text-semibold hover:text-orange-500 py-2 transition-all'>
                    Comment gagner de l''argent avec son telephone
                  </p>
                  <div className='h-[1px] bg-slate-400 w-full my-2 '></div>
                  <span className='font-thin'>
                    Posté par <span className='text-blue-400 '>Kimeyada</span>{" "}
                    le 12/02/2023
                  </span>
                </div>
                <img
                  className='justify-center items-center w-[100px] object-contain'
                  src={`${process.env.REACT_APP_CLIENT_URL}/images/pc.png`}
                  alt='PC'
                />
              </div>
            </div>

            <div className='mt-0 shadow-lg p-2 rounded-sm cursor-pointer hover:shadow-slate-200'>
              <h3 className='text-slate-400 font-semibold text-xl'>
                Ventes & Marketing
              </h3>
              <div className='flex md-lg:justify-between'>
                <div className='gap-2'>
                  <p className='text-semibold hover:text-orange-500 py-2 transition-all'>
                    Comment gagner de l''argent avec son telephone
                  </p>
                  <div className='h-[1px] bg-slate-400 w-full my-2 '></div>
                  <span className='font-thin'>
                    Posté par <span className='text-blue-400 '>Kimeyada</span>{" "}
                    le 12/02/2023
                  </span>
                </div>
                <img
                  className='justify-center items-center w-[100px] object-contain'
                  src={`${process.env.REACT_APP_CLIENT_URL}/images/pc.png`}
                  alt='PC'
                />
              </div>
            </div>
          </div>
        </section>

        <section className=' h-full flex justify-center items-center md-lg:flex md-lg:flex-col md-lg:w-[90%] md:w-[90%]  sm:w-[95%] w-[85%] mx-auto bg-white'>
          <div className='w-[95%] flex flex-wrap mx-auto'>
            <div className='grid w-full grid-cols-3 md-lg:grid-cols-2 md:grid-cols-1 gap-7'>
              <div className='overflow-hidden'>
                <h1 className='font-bold text-orange-600 text-2xl py-5'>
                  Vêtements & Accessoires
                </h1>
                <div className='pr-2 py-2 justify-center items-center mb-4'>
                  <div className='shadow-md px-4 py-4 mb-4 hover:shadow-indigo-500/30 cursor-pointer'>
                    <img
                      className='justify-center items-center w-[90%] h-auto'
                      src={`https://img.baba-blog.com/2025/02/sexy-woman-in-office-ready-orange-wide-leg-yoga-pants.jpg?x-oss-process=style%2Ffull`}
                      alt='PC'
                    />
                    <p className='font-semibold text-black py-3 hover:text-orange-500 cursor-pointer text-sm '>
                      Comment porter un pantalon de yoga à jambes larges pour le
                      bureau
                    </p>
                    <div className='h-[1px] bg-slate-400 w-full my-2'></div>
                    <span className='font-thin'>
                      Posté par <span className='text-blue-400 '>Kimeyada</span>{" "}
                      le 12/02/2023
                    </span>
                  </div>
                </div>
                <div className='pr-2 py-2 justify-center items-center mb-4'>
                  <div className='shadow-md px-4 py-4 mb-4 hover:shadow-indigo-500/30 cursor-pointer'>
                    <img
                      className='justify-center items-center w-[90%] h-auto'
                      src={`https://img.baba-blog.com/2025/02/a-romantic-love-themed-ribbon-jeans.jpg?x-oss-process=style%2Ffull`}
                      alt='PC'
                    />
                    <p className='font-semibold text-black py-3 hover:text-orange-500 cursor-pointer text-sm '>
                      Comment porter un jean à ruban pour chaque occasion
                    </p>
                    <div className='h-[1px] bg-slate-400 w-full my-2'></div>
                    <span className='font-thin'>
                      Posté par <span className='text-blue-400 '>Kimeyada</span>{" "}
                      le 12/02/2023
                    </span>
                  </div>
                </div>
              </div>

              <div className='overflow-hidden'>
                <h1 className='font-bold text-orange-600 text-2xl py-5'>
                  Électronique grand public
                </h1>
                <div className='pr-2 py-2 justify-center items-center mb-4'>
                  <div className='shadow-md px-4 py-4 mb-4 hover:shadow-indigo-500/30 cursor-pointer'>
                    <img
                      className='justify-center items-center w-[90%] h-auto'
                      src={`https://img.baba-blog.com/2025/04/Samsungs-fridge.jpg?x-oss-process=style%2Fmedium_large`}
                      alt='PC'
                    />
                    <p className='font-semibold text-black py-3 hover:text-orange-500 text-sm cursor-pointer'>
                      Nouvelle fonctionnalité du réfrigérateur Samsung : «
                      Salut, Bixby » trouve votre téléphone
                    </p>
                    <div className='h-[1px] bg-slate-400 w-full my-2'></div>
                    <span className='font-thin'>
                      Posté par <span className='text-blue-400 '>Kimeyada</span>{" "}
                      le 12/02/2023
                    </span>
                  </div>
                </div>
                <div className='pr-2 py-2 justify-center items-center mb-4'>
                  <div className='shadow-md px-4 py-4 mb-4 hover:shadow-indigo-500/30 cursor-pointer'>
                    <img
                      className='justify-center items-center w-[90%] h-auto'
                      src={`https://img.baba-blog.com/2025/04/Redmi-13x-Launches-with-Refreshed-Design-and-Familiar-Specs.jpg?x-oss-process=style%2Fmedium_large`}
                      alt='PC'
                    />
                    <p className='font-semibold text-black py-3 hover:text-orange-500 cursor-pointer text-sm '>
                      Redmi 13X est lancé avec un design actualisé et des
                      spécifications familières
                    </p>
                    <div className='h-[1px] bg-slate-400 w-full my-2'></div>
                    <span className='font-thin'>
                      Posté par <span className='text-blue-400 '>Kimeyada</span>{" "}
                      le 12/02/2023
                    </span>
                  </div>
                </div>
              </div>

              <div className='overflow-hidden'>
                <h1 className='font-bold text-orange-600 text-2xl py-5'>
                  Machinerie
                </h1>
                <div className='pr-2 py-2 justify-center items-center mb-4'>
                  <div className='shadow-md px-4 py-4 mb-4 hover:shadow-indigo-500/30 cursor-pointer'>
                    <img
                      className='justify-center items-center w-[90%] h-auto'
                      src={`https://img.baba-blog.com/2025/02/water-filter.jpg?x-oss-process=style%2Fmedium_large`}
                      alt='PC'
                    />
                    <p className='font-semibold text-black py-3 hover:text-orange-500 cursor-pointer text-sm'>
                      Analyse des filtres à eau les plus vendus sur Amazon aux
                      États-Unis en 2024
                    </p>
                    <div className='h-[1px] bg-slate-400 w-full my-2'></div>
                    <span className='font-thin'>
                      Posté par <span className='text-blue-400 '>Kimeyada</span>{" "}
                      le 12/02/2023
                    </span>
                  </div>
                </div>
                <div className='pr-2 py-2 justify-center items-center mb-4'>
                  <div className='shadow-md px-4 py-4 mb-4 hover:shadow-indigo-500/30 cursor-pointer'>
                    <img
                      className='justify-center items-center w-[90%] h-auto'
                      src={`https://img.baba-blog.com/2025/04/A-laboratory-orbital-shaker-with-multiple-flasks-secured-in-place-with-clamps.jpg?x-oss-process=style%2Fmedium_large`}
                      alt='PC'
                    />
                    <p className='font-semibold text-black py-3 hover:text-orange-500 cursor-pointer text-sm'>
                      Votre guide ultime des shakers en 2025
                    </p>
                    <div className='h-[1px] bg-slate-400 w-full my-2'></div>
                    <span className='font-thin'>
                      Posté par <span className='text-blue-400 '>Kimeyada</span>{" "}
                      le 12/02/2023
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className=' h-full flex justify-center items-center md-lg:flex md-lg:flex-col md-lg:w-[90%] md:w-[90%]  sm:w-[95%] w-[85%] mx-auto bg-white'>
          <div className='w-[95%] flex flex-wrap mx-auto'>
            <div className='grid w-full grid-cols-3 md-lg:grid-cols-2 md:grid-cols-1 gap-7'>
              <div className='overflow-hidden'>
                <h1 className='font-bold text-orange-600 text-2xl py-5'>
                  Beauté et soins personnels
                </h1>
                <div className='pr-2 py-2 justify-center items-center mb-4'>
                  <div className='shadow-md px-4 py-4 mb-4 hover:shadow-indigo-500/30 cursor-pointer'>
                    <img
                      className='justify-center items-center w-[90%] h-auto'
                      src={`https://img.baba-blog.com/2025/03/hands-holding-a-valentines-gift-shaped-like-a-car.jpg?x-oss-process=style%2Fmedium_large`}
                      alt='PC'
                    />
                    <p className='font-semibold text-black py-3 hover:text-orange-500 cursor-pointer text-sm'>
                      Votre guide professionnel ultime sur les tendances de la
                      Saint-Valentin pour 2026
                    </p>
                    <div className='h-[1px] bg-slate-400 w-full my-2'></div>
                    <span className='font-thin'>
                      Posté par <span className='text-blue-400 '>Kimeyada</span>{" "}
                      le 12/02/2023
                    </span>
                  </div>
                </div>
                <div className='pr-2 py-2 justify-center items-center mb-4'>
                  <div className='shadow-md px-4 py-4 mb-4 hover:shadow-indigo-500/30 cursor-pointer'>
                    <img
                      className='justify-center items-center w-[90%] h-auto'
                      src={`https://img.baba-blog.com/2025/03/A-woman-with-new-brows-in-a-good-shape.jpg?x-oss-process=style%2Fmedium_large`}
                      alt='PC'
                    />
                    <p className='font-semibold text-black py-3 hover:text-orange-500 cursor-pointer text-sm'>
                      Pourquoi les Nano Brows font fureur en 2025
                    </p>
                    <div className='h-[1px] bg-slate-400 w-full my-2'></div>
                    <span className='font-thin'>
                      Posté par <span className='text-blue-400 '>Kimeyada</span>{" "}
                      le 12/02/2023
                    </span>
                  </div>
                </div>
              </div>

              <div className='overflow-hidden'>
                <h1 className='font-bold text-orange-600 text-2xl py-5'>
                  les énergies renouvelables
                </h1>
                <div className='pr-2 py-2 justify-center items-center mb-4'>
                  <div className='shadow-md px-4 py-4 mb-4 hover:shadow-indigo-500/30 cursor-pointer'>
                    <img
                      className='justify-center items-center w-[90%] h-auto'
                      src={`https://img.baba-blog.com/2024/12/Solar-panels-installation-on-rooftop.jpg?x-oss-process=style%2Fmedium_large`}
                      alt='PC'
                    />
                    <p className='font-semibold text-black py-3 hover:text-orange-500 cursor-pointer text-sm'>
                      Extraits d'actualités sur le solaire photovoltaïque en
                      Amérique du Nord : l'USITC prend en charge la...
                    </p>
                    <div className='h-[1px] bg-slate-400 w-full my-2'></div>
                    <span className='font-thin'>
                      Posté par <span className='text-blue-400 '>Kimeyada</span>{" "}
                      le 12/02/2023
                    </span>
                  </div>
                </div>
                <div className='pr-2 py-2 justify-center items-center mb-4'>
                  <div className='shadow-md px-4 py-4 mb-4 hover:shadow-indigo-500/30 cursor-pointer'>
                    <img
                      className='justify-center items-center w-[90%] h-auto'
                      src={`https://img.baba-blog.com/2024/12/Solar-energy-panel.jpg?x-oss-process=style%2Fmedium_large`}
                      alt='PC'
                    />
                    <p className='font-semibold text-black py-3 hover:text-orange-500 cursor-pointer text-sm'>
                      La Commission européenne donne son feu vert à un programme
                      italien de 9.7 milliards d'euros en
                    </p>
                    <div className='h-[1px] bg-slate-400 w-full my-2'></div>
                    <span className='font-thin'>
                      Posté par <span className='text-blue-400 '>Kimeyada</span>{" "}
                      le 12/02/2023
                    </span>
                  </div>
                </div>
              </div>

              <div className='overflow-hidden'>
                <h1 className='font-bold text-orange-600 text-2xl py-5'>
                  Pièces et accessoires de véhicules
                </h1>
                <div className='pr-2 py-2 justify-center items-center mb-4'>
                  <div className='shadow-md px-4 py-4 mb-4 hover:shadow-indigo-500/30 cursor-pointer'>
                    <img
                      className='justify-center items-center w-[90%] h-auto'
                      src={`https://img.baba-blog.com/2025/04/stock-image-of-a-BMW-engine.jpg?x-oss-process=style%2Fmedium_large`}
                      alt='PC'
                    />
                    <p className='font-semibold text-black py-3 hover:text-orange-500 cursor-pointer text-sm'>
                      Guide complet sur le réglage du moteur BMW N52
                    </p>
                    <div className='h-[1px] bg-slate-400 w-full my-2'></div>
                    <span className='font-thin'>
                      Posté par <span className='text-blue-400 '>Kimeyada</span>{" "}
                      le 12/02/2023
                    </span>
                  </div>
                </div>
                <div className='pr-2 py-2 justify-center items-center mb-4'>
                  <div className='shadow-md px-4 py-4 mb-4 hover:shadow-indigo-500/30 cursor-pointer'>
                    <img
                      className='justify-center items-center w-[90%] h-auto'
                      src={`https://img.baba-blog.com/2025/04/The-GWM-Boer-pickup-parked-outside.jpg?x-oss-process=style%2Fmedium_large`}
                      alt='PC'
                    />
                    <p className='font-semibold text-black py-3 hover:text-orange-500 cursor-pointer text-sm'>
                      Top 10 des marques de pick-up chinoises à connaître
                    </p>
                    <div className='h-[1px] bg-slate-400 w-full my-2'></div>
                    <span className='font-thin'>
                      Posté par <span className='text-blue-400 '>Kimeyada</span>{" "}
                      le 12/02/2023
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className=' h-full flex justify-center items-center md-lg:flex md-lg:flex-col md-lg:w-[90%] md:w-[90%]  sm:w-[95%] w-[85%] mx-auto bg-white'>
          <div className='w-[95%] flex flex-wrap mx-auto'>
            <div className='grid w-full grid-cols-3 md-lg:grid-cols-2 md:grid-cols-1 gap-7'>
              <div className='overflow-hidden'>
                <h1 className='font-bold text-orange-600 text-2xl py-5'>
                  Vêtements & Accessoires
                </h1>
                <div className='pr-2 py-2 justify-center items-center mb-4'>
                  <div className='shadow-md px-4 py-4 mb-4 hover:shadow-indigo-500/30 cursor-pointer'>
                    <img
                      className='justify-center items-center w-[90%] h-auto'
                      src={`/images/pc.png`}
                      alt='PC'
                    />
                    <p className='font-semibold text-black py-3 hover:text-orange-500 cursor-pointer text-sm'>
                      Comment porter un pantalon de yoga à jambes larges pour le
                      bureau
                    </p>
                    <div className='h-[1px] bg-slate-400 w-full my-2'></div>
                    <span className='font-thin'>
                      Posté par <span className='text-blue-400 '>Kimeyada</span>{" "}
                      le 12/02/2023
                    </span>
                  </div>
                </div>
                <div className='pr-2 py-2 justify-center items-center mb-4'>
                  <div className='shadow-md px-4 py-4 mb-4 hover:shadow-indigo-500/30 cursor-pointer'>
                    <img
                      className='justify-center items-center w-[90%] h-auto'
                      src={`/images/pc.png`}
                      alt='PC'
                    />
                    <p className='font-semibold text-black py-3 hover:text-orange-500 cursor-pointer'>
                      Comment porter un pantalon de yoga à jambes larges pour le
                      bureau
                    </p>
                    <div className='h-[1px] bg-slate-400 w-full my-2'></div>
                    <span className='font-thin'>
                      Posté par <span className='text-blue-400 '>Kimeyada</span>{" "}
                      le 12/02/2023
                    </span>
                  </div>
                </div>
              </div>

              <div className='overflow-hidden'>
                <h1 className='font-bold text-orange-600 text-2xl py-5'>
                  Vêtements & Accessoires
                </h1>
                <div className='pr-2 py-2 justify-center items-center mb-4'>
                  <div className='shadow-md px-4 py-4 mb-4 hover:shadow-indigo-500/30 cursor-pointer'>
                    <img
                      className='justify-center items-center w-[90%] h-auto'
                      src={`/images/pc.png`}
                      alt='PC'
                    />
                    <p className='font-semibold text-black py-3 hover:text-orange-500 cursor-pointer'>
                      Comment porter un pantalon de yoga à jambes larges pour le
                      bureau
                    </p>
                    <div className='h-[1px] bg-slate-400 w-full my-2'></div>
                    <span className='font-thin'>
                      Posté par <span className='text-blue-400 '>Kimeyada</span>{" "}
                      le 12/02/2023
                    </span>
                  </div>
                </div>
                <div className='pr-2 py-2 justify-center items-center mb-4'>
                  <div className='shadow-md px-4 py-4 mb-4 hover:shadow-indigo-500/30 cursor-pointer'>
                    <img
                      className='justify-center items-center w-[90%] h-auto'
                      src={`/images/pc.png`}
                      alt='PC'
                    />
                    <p className='font-semibold text-black py-3 hover:text-orange-500 cursor-pointer'>
                      Comment porter un pantalon de yoga à jambes larges pour le
                      bureau
                    </p>
                    <div className='h-[1px] bg-slate-400 w-full my-2'></div>
                    <span className='font-thin'>
                      Posté par <span className='text-blue-400 '>Kimeyada</span>{" "}
                      le 12/02/2023
                    </span>
                  </div>
                </div>
              </div>

              <div className='overflow-hidden'>
                <h1 className='font-bold text-orange-600 text-2xl py-5'>
                  Vêtements & Accessoires
                </h1>
                <div className='pr-2 py-2 justify-center items-center mb-4'>
                  <div className='shadow-md px-4 py-4 mb-4 hover:shadow-indigo-500/30 cursor-pointer'>
                    <img
                      className='justify-center items-center w-[90%] h-auto'
                      src={`/images/pc.png`}
                      alt='PC'
                    />
                    <p className='font-semibold text-black py-3 hover:text-orange-500 cursor-pointer'>
                      Comment porter un pantalon de yoga à jambes larges pour le
                      bureau
                    </p>
                    <div className='h-[1px] bg-slate-400 w-full my-2'></div>
                    <span className='font-thin'>
                      Posté par <span className='text-blue-400 '>Kimeyada</span>{" "}
                      le 12/02/2023
                    </span>
                  </div>
                </div>
                <div className='pr-2 py-2 justify-center items-center mb-4'>
                  <div className='shadow-md px-4 py-4 mb-4 hover:shadow-indigo-500/30 cursor-pointer'>
                    <img
                      className='justify-center items-center w-[90%] h-auto'
                      src={`/images/pc.png`}
                      alt='PC'
                    />
                    <p className='font-semibold text-black py-3 hover:text-orange-500 cursor-pointer'>
                      Comment porter un pantalon de yoga à jambes larges pour le
                      bureau
                    </p>
                    <div className='h-[1px] bg-slate-400 w-full my-2'></div>
                    <span className='font-thin'>
                      Posté par <span className='text-blue-400 '>Kimeyada</span>{" "}
                      le 12/02/2023
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default Blogs;
